import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Btech_AdmissionELe from './btech_admissionELe'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission"/>
            <Btech_AdmissionELe />
        </>
    )
}

export default Main